<template>
	<div class="text-left">
		<div class="background" v-if="$route.params.withdraw == 'pay'">
			<img src="/static/assets/bwlogo.png"/>
			<h4 class="text-band">Güncel Hesaplarımızı Canlı Destek Ekibimizden alabilirsiniz.</h4>
		</div>
		<banktransfer v-if="$route.params.withdraw == 'payx'" />
		<withdraw v-if="$route.params.withdraw == 'withdraw'" />
	</div>
</template>

<script>
    import withdraw from '@/components/user/transactions/withdraw'
    import banktransfer from '@/components/payments/form/banktransfer'
    export default {
        name: "bank_transfer",
        components: {banktransfer, withdraw}
    }
</script>

<style scoped>
	.background {
		height: 400px;
		padding: 140px 20px;
		background-image:url('/static/assets/img/help/call_woman.jpg');
		background-size: cover;
	}
	.text-band{
		color: #000;
	}
</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/bank_transfer.vue